import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["languageText", "menu", "dropdown"]

  connect() {
    const locale = this.getCookie("locale") || "es"
    this.updateLanguageText(locale)
    
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  toggleMenu() {
    this.menuTarget.classList.toggle('hidden')
  }

  handleClickOutside(event) {
    if (!this.dropdownTarget.contains(event.target)) {
      this.menuTarget.classList.add('hidden')
    }
  }

  changeLanguage(event) {
    const newLocale = event.currentTarget.dataset.locale
    this.setCookie("locale", newLocale)
    this.updateLanguageText(newLocale)
    window.location.reload()
  }

  updateLanguageText(locale) {
    this.languageTextTarget.textContent = locale.toUpperCase()
  }

  getCookie(name) {
    const cookies = document.cookie.split("; ")
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=")
      if (cookieName === name) return cookieValue
    }
    return null
  }

  setCookie(name, value) {
    document.cookie = `${name}=${value}; path=/`
  }
}
